// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3Ag7W","balanceDisclaimer":"posDashboard_balanceDisclaimer__2B3Dp"};